export const apiconst = {
    //ENDPOINT: "https://dashboardApi.touchsoft.akeodev.com/",
    ENDPOINT:"https://lth-bi-api.touchsoft.no/",
    //ENDPOINT:"https://localhost:5001/",
    VERSION:"v1/api/",
    //ENDPOINT:"https://bi-api.touchsoft.no/",
    LOGIN: "authenticate/",
    FORGOTPASSWORD: "ForgotPassword",
    VALIDATERESETTOKEN: "ValidateResetToken",
    RESETPASSWORD: "ResetPassword",
    DASHBOARD: "dashboardApi",
    REMEMBERME: "SetRememberMe",
    WEBDASHBOARDSTORAGE: "WebDashboardStorage",
    SETSTORE: "SetStore",
    CHECKAUTHENTICATION: "CheckAuthentication",
    GETWORKINGMODE:"GetWorkingMode"
}